import { DateFormatProps } from '@blueprintjs/datetime';
import moment from 'moment';

export const getMomentDateFormatter = (format: string, locale: string = 'en'): DateFormatProps => {
    return {
        formatDate: (date) => moment(date).locale(locale).format(format),
        parseDate: (str) => moment(str, format).locale(locale).toDate(),
    };
};
